const propertydef = {
    common: [
        {
            name: 'id',
            datatype: 'display'
        },
        {
            name: 'x',
            datatype: 'display'
        },
        {
            name: 'y',
            datatype: 'display'
        },
        {
            name: 'module',
            datatype: 'display'
        },
        {
            name: 'type',
            datatype: 'display'
        },
        {
            name: 'prettyname',
            datatype: 'text',
            default: ''
        },
        {
            name: 'bm_route_only',
            datatype: 'bool',
            default: false,
        },
        {
            name: 'bm',
            datatype: 'adressport',
            field_a: {
                name: 'fbaddr',
                datatype: 'domain',
                domain: 'bmaddr',
                default: ''
            },
            field_b: {
                name: 'fbport',
                datatype: 'text',
                default: ''
            }
        },
        {
            name: 'bmbd',
            datatype: 'domain',
            default: '',
            domain: ['none', 'east', 'west', 'south', 'north', 'center']
        }

    ],
    sg: [
        {
            name: 'accessory',
            datatype: 'adressport',
            field_a: {
                name: 'addr',
                datatype: 'domain',
                domain: 'accaddr',
                default: ''
            },
            field_b: {
                name: 'port',
                datatype: 'text',
                default: ''
            }
        },
        {
            name: 'notarget',
            datatype: 'bool',
            default: false,
        },
        {
            name: 'autosg',
            datatype: 'bool',
            default: false,
        },
        {
            name: 'searchwait',
            datatype: 'text',
            default: 0
        },
        {
            name: 'block',
            datatype: 'text',
            default: 'NA'
        },
        {
            name: 'shunt_sg_east',
            datatype: 'bool',
            default: false,
        },
        {
            name: 'shunt_sg_west',
            datatype: 'bool',
            default: false,
        },
        {
            name: 'shunt_button_east',
            datatype: 'bool',
            default: false,
        },
        {
            name: 'shunt_button_west',
            datatype: 'bool',
            default: false,
        },
        {
            name: 'addr_e',
            datatype: 'domain',
            default: '',
            domain: 'addr'
        },
        {
            name: 'port_e',
            datatype: 'text',
            default: ''
        },
        {
            name: 'addr_w',
            datatype: 'domain',
            default: '',
            domain: 'addr'
        },
        {
            name: 'port_w',
            datatype: 'text',
            default: ''
        },
        {
            name: 'bm_brake',
            datatype: 'adressport',
            field_a: {
                name: 'bm_brake_addr',
                datatype: 'domain',
                domain: 'addr',
                default: ''
            },
            field_b: {
                name: 'bm_brake_port',
                datatype: 'text',
                default: ''
            }
        },
        {
            name: 'bm_stop',
            datatype: 'adressport',
            field_a: {
                name: 'bm_stop_addr',
                datatype: 'domain',
                domain: 'addr',
                default: ''
            },
            field_b: {
                name: 'bm_stop_port',
                datatype: 'text',
                default: ''
            }
        },
        {
            name: 'subtype',
            datatype: 'domain',
            default: 'shunt',
            domain: ['main', 'shunt', 'line', 'linedir', 'bauf']
        },
        {
            name: 'ori',
            datatype: 'domain',
            default: 'west',
            domain: ['east', 'west']
        },
        {
            name: 'streckenblock',
            datatype: 'domain',
            default: '',
            domain: 'streckenblock'
        },
        {
            name: 'ori_flipped',
            datatype: 'bool',
            default: false,
        },
    ],
    tt: [
        {
            name: 'accessory',
            type: 'adressport',
            field_a: {
                name: 'addr',
                datatype: 'domain',
                domain: 'addr',
                default: ''
            },
            field_b: {
                name: 'port',
                datatype: 'text',
                default: ''
            }
        },
        {
            name: 'positions',
            datatype: 'array',
            domain: 'positions',
            fields: [
                {
                    name: 'id',
                    datatype: 'display'
                },
                {
                    name: 'ang',
                    datatype: 'text',
                    default: 0
                },
                {
                    name: 'asp',
                    datatype: 'text',
                    default: 0
                },
                {
                    name: 'track',
                    datatype: 'bool',
                    default: false
                },
                {
                    name: 'bm',
                    datatype: 'adressport',
                    field_a: {
                        name: 'fbaddr',
                        datatype: 'domain',
                        domain: 'addr',
                        default: ''
                    },
                    field_b: {
                        name: 'fbport',
                        datatype: 'text',
                        default: ''
                    }
                },
            ]
        }
        ],
    sw: [
        {
            name: 'accessory',
            datatype: 'adressport',
            field_a: {
                name: 'addr',
                datatype: 'domain',
                domain: 'accaddr',
                default: ''
            },
            field_b: {
                name: 'port',
                datatype: 'text',
                default: ''
            }
        },
        {
            name: 'script',
            datatype: 'text',
            default: '',
        },
        {
            name: 'ori',
            datatype: 'domain',
            default: 'west',
            domain: ['east', 'west']
        },
        {
            name: 'subtype',
            datatype: 'domain',
            default: 'left',
            domain: ['right', 'left', 'aussen', 'taster']
        },
        {
            name: 'shuntingrouteonly',
            datatype: 'domain',
            default: 'none',
            domain: ['straight', 'turnout', 'none']
        },
        {
            name: 'trigger_a',
            datatype: 'trigger',
            field_a: {
                name: 'trigger_a_addr',
                datatype: 'domain',
                domain: 'bmaddr',
                default: ''
            },
            field_b: {
                name: 'trigger_a_port',
                datatype: 'text',
                default: ''
            },
            field_c: {
                name: 'trigger_a_aspect',
                datatype: 'text',
                default: '0'
            },
            field_d: {
                name: 'trigger_a_delay',
                datatype: 'text',
                default: '0'
            }
        },
        {
            name: 'trigger_b',
            datatype: 'trigger',
            field_a: {
                name: 'trigger_b_addr',
                datatype: 'domain',
                domain: 'bmaddr',
                default: ''
            },
            field_b: {
                name: 'trigger_b_port',
                datatype: 'text',
                default: ''
            },
            field_c: {
                name: 'trigger_b_aspect',
                datatype: 'text',
                default: '0'
            },
            field_d: {
                name: 'trigger_b_delay',
                datatype: 'text',
                default: '0'
            }
        },
        {
            name: 'trigger_d',
            datatype: 'trigger',
            field_a: {
                name: 'trigger_d_addr',
                datatype: 'domain',
                domain: 'bmaddr',
                default: ''
            },
            field_b: {
                name: 'trigger_d_port',
                datatype: 'text',
                default: ''
            },
            field_c: {
                name: 'trigger_d_aspect',
                datatype: 'text',
                default: '0'
            },
            field_d: {
                name: 'trigger_d_delay',
                datatype: 'text',
                default: '0'
            }
        },
        {
            name: 'trigger_e',
            datatype: 'trigger',
            field_a: {
                name: 'trigger_e_addr',
                datatype: 'domain',
                domain: 'bmaddr',
                default: ''
            },
            field_b: {
                name: 'trigger_e_port',
                datatype: 'text',
                default: ''
            },
            field_c: {
                name: 'trigger_e_aspect',
                datatype: 'text',
                default: '0'
            },
            field_d: {
                name: 'trigger_e_delay',
                datatype: 'text',
                default: '0'
            }
        },
    ],
    tk: [
        {
            name: 'connect',
            datatype: 'text',
            default: ''
        },
        {
            name: 'ori',
            datatype: 'domain',
            default: 'east',
            domain: ['east', 'west', 'north', 'south'],
            constraint: '@type=curve',
        },
        {
            name: 'subtype',
            datatype: 'domain',
            default: '',
            domain: ['', 'buffer', 'connector', 'curve', 'doublecurve'],
        }
    ],
    bk: [
        {
            name: 'subtype',
            datatype: 'domain',
            default: '',
            domain: ['', 'streckenblock'],
        }
    ],
    lc: [
        {
            name: 'id',
            datatype: 'display'
        },
        {
            name: 'longname',
            datatype: 'text',
            default: '',
        },
        {
            name: 'shortname',
            datatype: 'text',
            default: '',
        }
    ],
    module: [
        {
            name: 'id',
            datatype: 'display'
        },
        {
            name: 'prettyname',
            datatype: 'text',
            default: ''
        },
        {
            name: 'scenario',
            datatype: 'text',
            default: ''
        },
        {
            name: 'w',
            datatype: 'text',
            default: '12'
        },
        {
            name: 'h',
            datatype: 'text',
            default: '4'
        }
    ]


}

export default propertydef